var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center w-full h-full flex-col text-gray-500"},[_c('h1',{staticClass:"text-4xl"},[_vm._v(" 404 Not Found ")]),_c('div',{staticClass:"text-gray-600 mt-5"},[_c('button',{staticClass:"mr-2",on:{"click":_vm.back}},[_vm._v("前页")]),_c('router-link',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }